var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3X HIDE ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.75,10.62A3.24,3.24,0,0,1,11,7.53l1-1c-6.16-1.32-10.49,4-10.49,4a13.43,13.43,0,0,0,3.58,2.91l1.83-1.83A3.16,3.16,0,0,1,6.75,10.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.11,7.77l-2,2a3.17,3.17,0,0,1,.12.88,3.26,3.26,0,0,1-4.14,3.13l-.9.9c2.9.58,6.54-.1,10.47-4.09A16.81,16.81,0,0,0,15.11,7.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,11.88a1.26,1.26,0,0,0,1.27-1.26.76.76,0,0,0,0-.15l3.81-3.82a.16.16,0,0,0,0-.22l-.79-.79a.16.16,0,0,0-.22,0L10.31,9.39a1.55,1.55,0,0,0-.31,0,1.26,1.26,0,0,0-1.26,1.27,1.1,1.1,0,0,0,0,.31L5.26,14.44a.17.17,0,0,0,0,.23l.79.78a.14.14,0,0,0,.22,0l3.58-3.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.525fc2c968bd0f95e7228a01bd680494.svg";
export { ForwardRef as ReactComponent };